import(/* webpackMode: "eager" */ "/vercel/path0/app/charity/src/app/(authenticated)/(home)/page.tsx");
